import axios from 'axios'
import { publicApiURL, platformWeb } from 'src/consumer/services'

// Mounted under /api/nc (CDN-bypass) — see PublicMedicalCertificateValidationController.
const BASE = '/api/nc/medical-certificate/validate'

function unwrap(res) {
  return res?.data || {}
}

/** Best-effort device / browser / locale / location context, recorded in the access log. */
export function buildClientMeta() {
  try {
    const ua = navigator.userAgent || ''
    const browser = /edg/i.test(ua)
      ? 'Edge'
      : /opr|opera/i.test(ua)
        ? 'Opera'
        : /chrome|crios/i.test(ua)
          ? 'Chrome'
          : /firefox|fxios/i.test(ua)
            ? 'Firefox'
            : /safari/i.test(ua)
              ? 'Safari'
              : 'Other'
    const os = /android/i.test(ua)
      ? 'Android'
      : /iphone|ipad|ipod/i.test(ua)
        ? 'iOS'
        : /windows/i.test(ua)
          ? 'Windows'
          : /mac os/i.test(ua)
            ? 'macOS'
            : /linux/i.test(ua)
              ? 'Linux'
              : 'Other'
    const device = /mobile|android|iphone|ipod/i.test(ua) ? 'Mobile' : /ipad|tablet/i.test(ua) ? 'Tablet' : 'Desktop'
    return {
      device,
      browser,
      os,
      platform: navigator.platform || '',
      language: navigator.language || '',
      timeZone: (Intl.DateTimeFormat().resolvedOptions() || {}).timeZone || '',
      screen: typeof window !== 'undefined' && window.screen ? `${window.screen.width}x${window.screen.height}` : '',
      referrer: typeof document !== 'undefined' ? document.referrer || '' : '',
    }
  } catch (e) {
    return {}
  }
}

/**
 * Step 1 — request access. For OPEN-policy certificates the response carries the document directly
 * (open=true); otherwise a WhatsApp OTP is sent (requiresOtp=true + sessionId).
 */
export async function startValidation(certId, { mobile, viewerName, recaptchaToken, clientMeta }) {
  try {
    const res = await axios.post(`${publicApiURL}${BASE}/otp/send?platform=${platformWeb}`, {
      certId,
      mobile,
      viewerName,
      recaptchaToken,
      clientMeta,
    })
    return unwrap(res)
  } catch (err) {
    return err?.response?.data || { code: 5000, message: 'Network error. Please try again.' }
  }
}

/** Step 2 — verify the OTP; returns validity + (when allowed) certificate details + pdfUrl. */
export async function verifyValidation(certId, { sessionId, otp, viewerName, recaptchaToken, clientMeta }) {
  try {
    const res = await axios.post(`${publicApiURL}${BASE}/otp/verify?platform=${platformWeb}`, {
      certId,
      sessionId,
      otp,
      viewerName,
      recaptchaToken,
      clientMeta,
    })
    return unwrap(res)
  } catch (err) {
    return err?.response?.data || { code: 5000, message: 'Network error. Please try again.' }
  }
}
